import QAResumeEntity from "../../domain/entities/qa_resume.entity";

const fromJSON = (json: any): QAResumeEntity => {
    return {
        id: json.id,
        achieved: json.achieved,
        agent_score: json.agent_score,
        agent_sentiment: json.agent_sentiment,
        audio_name: json.audio_name,
        average_score: json.average_score,
        call_type: json.call_type,
        client_name: json.client_name,
        created_at: json.created_at,
        customer_score: json.customer_score,
        customer_sentiment: json.customer_sentiment,
        end_at: json.end_at,
        human_agent_name: json.human_agent_name,
        job_id: json.job_id,
        job_status: json.job_status,
        operation_name: json.operation_name,
        qa_agent_name: json.qa_agent_name,
        start_at: json.start_at,
        target: json.target,
    };
}

const QAResumeDto = {
    fromJSON,
}

export default QAResumeDto;